import React, { Component } from 'react'
import Quote from './Quote'
import PageDot from '../shared/PageDot'

export default class Quotes extends Component {
  state = {
    page: 1,
  }

  onTouchStart = (e) => {
    const { touches } = e
    this.startTouches = touches[0].screenX
  }

  onTouchMove = (e) => {
    const { touches } = e
    this.endTouches = touches[0].screenX
  }

  onToucheEnd = () => {
    const direction = this.endTouches - this.startTouches
    if (direction < 0) {
      this.setPage(1)
    } else {
      this.setPage(-1)
    }
  }

  setPage = (p) => {
    const { page } = this.state
    const { quotes } = this.props
    const nextPage = page + p
    if (nextPage <= quotes.length && nextPage > 0) {
      this.setState({ page: nextPage })
    }
  }

  renderPagination = () => {
    const { quotes } = this.props
    const { page } = this.state
    if (quotes.length > 1) {
      return (
        <div className="quotes-widget__pagination">
          {(new Array(quotes.length)).fill('').map((i, key) => (
            <PageDot
              key={key}
              active={key === (page - 1)}
              onClick={() => this.setState({ page: key + 1 })}
            />
          ))}
        </div>
      )
    }
    return null
  }

  render() {
    const { quotes } = this.props
    const { page } = this.state
    return (
      <React.Fragment>
        <div
          onTouchStart={this.onTouchStart}
          onTouchMove={this.onTouchMove}
          onTouchEnd={this.onToucheEnd}
        >
          {quotes.map((quote, key) => (
            <Quote
              key={key}
              {...quote}
              active={key === (page - 1)}
              position={key - (page - 1)}
            />
          ))}
        </div>
        {this.renderPagination()}
      </React.Fragment>
    )
  }
}
